import {CoreModel} from '../../model/CoreModel';
import CoreMessageDispatcher from '../../controller/CoreMessageDispatcher';
import CoreEvents from '../../events/CoreEvents';
import SoundEvents from '../../events/SoundEvents';
import {GotoNewState} from './GotoNewState';

const NavToNewState = doThat => {
    //
    return GotoNewState(doThat).then(doThat => {
        return new Promise(resolve => {
            const model = CoreModel.instance();
            const _dispatcher = CoreMessageDispatcher.instance();
            //
            // Force open Event if it is the state
            if (model.isEventState) {
                model.currentEventOpened = true;

                if (model.currentEventOpenedChanged) {
                    model.resetCurrentEventOpenedChanged();
                    _dispatcher.emit(CoreEvents.CURRENT_EVENT_STATE_CHANGED);
                }

                if (model.soundChannelStateChanged) {
                    model.resetSoundChannelStateChanged();
                    _dispatcher.emit(SoundEvents.CHANNEL_STATE_CHANGED);
                }
            }
            resolve(doThat);
        });
    });
};

export {NavToNewState};
